// Native Capacitor runtime detection.
//
// STEP-1 native-auth infrastructure (Apple + Google + verified-phone posture),
// authored fresh against current main. This module is dormant until the trio UI
// (Step 2) consumes it: on legacy web there is no Capacitor global, so
// isNativeCapacitorRuntime() is false and nothing here changes existing behavior.
const getDefaultCapacitorRuntime = () =>
  (typeof window !== 'undefined' ? window.Capacitor : undefined);

// True only inside the native Capacitor shell (iOS/Android). On web the global
// is absent or reports a web platform, so every native-only auth path stays off.
export const isNativeCapacitorRuntime = (capacitorRuntime = getDefaultCapacitorRuntime()) =>
  Boolean(
    capacitorRuntime &&
    typeof capacitorRuntime.isNativePlatform === 'function' &&
    capacitorRuntime.isNativePlatform()
  );
